export default __webpack_public_path__ + "assets/08_SaveMap.png";